import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row px-4 my-2" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_5 = { for: "patient-first-name" }
const _hoisted_6 = { class: "form-group col-12 col-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "patient-middle-initial" }, " Care Team ", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Care Team", -1 /* HOISTED */)
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "form-group col-12 col-lg-6"
}
const _hoisted_11 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-is-pre-admn-req"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Pre-Admission Evaluation")
], -1 /* HOISTED */)
const _hoisted_13 = { class: "col-12 row g-0" }
const _hoisted_14 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "patient-middle-initial" }, " Assign to ", -1 /* HOISTED */)
const _hoisted_16 = { class: "form-group col-12 col-lg-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "patient-middle-initial" }, " Evaluation Date ", -1 /* HOISTED */)
const _hoisted_18 = { class: "input-group date datepickerInput" }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_21 = { class: "col-12 row g-0" }
const _hoisted_22 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "patient-middle-initial" }, " Referral Diagnosis ", -1 /* HOISTED */)
const _hoisted_24 = { class: "form-group col-12 col-md-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "tolerable-pain-level" }, " Tolerable Pain Level", -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Tolerable Pain Level", -1 /* HOISTED */)
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "col-12 col-lg-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Diagnosis = _resolveComponent("Diagnosis")!
  const _component_DiagnosisTable = _resolveComponent("DiagnosisTable")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Clinical Information",
    "full-height": false,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", _hoisted_5, " Referring " + _toDisplayString(_ctx.isApplicationPalliative ? "Provider" : "Physician"), 1 /* TEXT */),
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getPhysicianList,
                value: _ctx.attendingPhysician,
                onValueChanged: _ctx.attendingPhysicianChanged,
                placeholder: "Start Typing..."
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.careTeamId) = $event))
              }, [
                _hoisted_8,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: team.id,
                    value: team.id
                  }, _toDisplayString(team.name), 9 /* TEXT, PROPS */, _hoisted_9))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.careTeamId]
              ])
            ])
          ]),
          (_ctx.showPreAdmissionEvaluation && !_ctx.isApplicationPalliative)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "referral-is-pre-admn-req",
                    class: "form-check-input au-target",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.isPreadmissionRequired) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.referral.isPreadmissionRequired]
                  ]),
                  _hoisted_12
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("section", _hoisted_13, [
            _withDirectives(_createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.usersFetch,
                value: _ctx.selectedUser,
                onValueChanged: _ctx.selectedUserChanged,
                placeholder: "Start Typing..."
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
            ], 512 /* NEED_PATCH */), [
              [_vShow, _ctx.referral.isPreadmissionRequired]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_DatePicker, { getDate: _ctx.handleDateChange }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("input", {
                      name: "preadmissionEvaluationDate",
                      type: "text",
                      class: "form-control",
                      placeholder: "MM/DD/YYYY",
                      value: _ctx.formatDateInput(_ctx.referral.preadmissionEvaluationDate),
                      onChange: _cache[2] || (_cache[2] = (e) => _ctx.handleDateChange(e.target.value, e.target.name)),
                      autocomplete: "off",
                      "date-format-only": ""
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_19),
                    _hoisted_20
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["getDate"])
            ], 512 /* NEED_PATCH */), [
              [_vShow, _ctx.referral.isPreadmissionRequired]
            ])
          ]),
          _createElementVNode("section", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createVNode(_component_Diagnosis, {
                "selected-diagnosis": _ctx.referralDiagnosis,
                classes: "d-inline-block w-100",
                "diagnosis-changed": _ctx.referralDiagnosisChanged,
                application: _ctx.referral.application
              }, null, 8 /* PROPS */, ["selected-diagnosis", "diagnosis-changed", "application"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _withDirectives(_createElementVNode("select", {
                name: "tolerable-pain-level",
                class: "form-select",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.tolerablePainLevel) = $event))
              }, [
                _hoisted_26,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.TolerablePainLevels), ([key, value]) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: value.value
                  }, _toDisplayString(value.value) + " - " + _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_27))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.tolerablePainLevel]
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_DiagnosisTable, {
                diagnosis: _ctx.referral.diagnoses,
                updateDiagnosis: _ctx.updateDiagnosis,
                referral: _ctx.referral,
                id: _ctx.referral.id
              }, null, 8 /* PROPS */, ["diagnosis", "updateDiagnosis", "referral", "id"])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}